import { Component, Input } from '@angular/core';
import { CreditVoucherCard } from 'src/app/model/card/credit-voucher-card';

@Component({
  selector: 'app-credit-voucher-card',
  templateUrl: './credit-voucher-card.component.html',
  styleUrls: ['./credit-voucher-card.component.scss']
})
export class CreditVoucherCardComponent {
  @Input() creditVoucherCards: CreditVoucherCard[] = [];
  constructor() {}
}
